<template>
  <main class="content">
    <HomeSwiper/>
    <HomeNav/>
    <img
      src="@/assets/ad.png"
      width="100%">
    <HomeNews :list="list"/>
    <van-tabbar v-model="active">
      <van-tabbar-item icon="wap-home" @click="changeNav($event)" code="home">首页</van-tabbar-item>
      <!--    隐藏就诊卡管理相关入口-->
      <!--
      <van-tabbar-item icon="idcard"@click="changeNav">就诊卡</van-tabbar-item>
      -->
      <van-tabbar-item icon="description" @click="changeNav($event)" code="order">订单</van-tabbar-item>
      <van-tabbar-item  icon="contact" @click="changeNav($event)" code="account">我的</van-tabbar-item>
    </van-tabbar>
    <!--    隐藏就诊卡管理相关入口-->
    <!--
    <picture
      class="add-card"
      @click="$router.push({name: 'card'})">
      <source
        srcset="@/assets/add-card-icon.webp"
        type="image/webp">
      <source
        srcset="@/assets/add-card-icon.png"
        type="image/png">
      <img
        src="@/assets/add-card-icon.png"
        width="80">
    </picture>
     -->
  </main>
</template>

<script>
import HomeSwiper from './components/HomeSwiper.vue';
import HomeNav from './components/HomeNav.vue';
import HomeNews from './components/HomeNews.vue';
import currentCardService from '@/libs/currentCard';
// import HTTP from '../../libs/HTTP';

export default {
  name: 'Home',
  components: {
    HomeSwiper,
    HomeNav,
    HomeNews,
  },
  data() {
    return {
      active: 0,
      list: [],
    };
  },
  mounted: function () {
    // 初始化激活索引
    this.active = this.getIndexByRoute(this.$route.name);
    //设置当前就诊卡，附带校验
    let setCurrentCardPromise = currentCardService.setCurrentCardWithValidate(this);
    setCurrentCardPromise.then(() => {
      // 进入首页的时候设置reloadFilmDetail
      // 用途看文件FilmTabs.vue里面解释
      window.localStorage.setItem('reloadFilmDetail', false);
    });
  },
  activated() {
    // 加载新闻,刷新阅读量
    this.loadNews();
  },
  watch: {
    $route(to) {
      this.active = this.getIndexByRoute(to.name);
    }
  },
  methods: {
    getIndexByRoute(routeName) {
      const map = { home: 0, order: 1, account: 2 };
      return map[routeName] || 0;
    },
    changeNav(event) {
      const code = event.currentTarget.getAttribute('code');
      if (code && this.$route.name !== code) {
        this.$router.push({ name: code });
      }
    },
    // 废弃了
    async loadNews() {
      // this.list = [];
      // const http = new HTTP('');
      // // 获取文章列表
      // const newsList = await http.get('https://blog.yikangbao.com.cn/wp-json/wp/v2/posts', { categories: 2, per_page: 3 });
      // newsList.forEach(async (element) => {
      //   const news = {};
      //   news.title = element.title.rendered;
      //   news.url = element.link;
      //   news.view = element.post_view_count;
      //   /* eslint-disable no-underscore-dangle */
      //   news.imgHref = element._links['wp:featuredmedia'][0].href;
      //   this.list.push(news);
      // });
      // // 获取文章对应的图片
      // this.list.forEach(async (element, index) => {
      //   const img = await http.get(element.imgHref);
      //   this.$set(this.list[index], 'img', img.guid.rendered);
      // });
    },
  },
};
</script>

<style scoped>
.content {
  background-color: #fff;
}

.add-card {
  position: fixed;
  right: 10px;
  bottom: 60px;
}
</style>
